import { IDotXetChungChi } from "../../../model/response/xet-chung-chi/IDotXetChungChi";
import { IDotXetChungChiPhamVi } from "../../../model/response/xet-chung-chi/IDotXetChungChiPhamVi";
import { IDotXetChungChiPhamViViewModel } from "../../../model/response/xet-chung-chi/IDotXetChungChiPhamViViewModel";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eDotXetChungChiPhamViActionsObj = {
    LOAD_BY_DOT_XET_START: 0,
    LOAD_BY_DOT_XET_SUCCESS: {} as IDotXetChungChiPhamViViewModel[],
    LOAD_BY_DOT_XET_ERROR: "",

    ADD_START: {} as IDotXetChungChiPhamVi,
    ADD_SUCCESS: undefined,
    ADD_ERROR: "",

    DELETE_START: 0,
    DELETE_SUCCESS: undefined,
    DELETE_ERROR: "",

    SHOW_ADD_MODAL: undefined,
    CLOSE_ADD_MODAL: undefined,
}

export const eDotXetChungChiPhamViActionIds = generateActionTypeIds(eDotXetChungChiPhamViActionsObj, "DOT_XET_CHUNG_CHI_PHAM_VI");
export type IDotXetChungChiPhamViActionTypes = IGenericActionType<typeof eDotXetChungChiPhamViActionsObj, "DOT_XET_CHUNG_CHI_PHAM_VI">;